import axios from "axios";
import qs from "qs";
import app from "../main.js";
import router from '../router'
import store from '../vuex/store'
//全局路由前置守卫
router.beforeEach((to, from, next) => {
	// 权限控制登录
  if (to.meta && to.meta.auth && !store.state.user.isLogin) {
    router.push({
      path: '/login',
    });
    return false;
  }else {
		next()
	}
});


/****** 创建axios实例 ******/
const service = axios.create({
    baseURL: process.env.BASE_URL,  // api的base_url
    timeout: 30000  // 请求超时时间
});




/****** request拦截器==>对请求参数做处理 ******/
service.interceptors.request.use(config => {
    app.$vux.loading.show({
        text: ''
    });
    config.method === 'post'
        ? config.data = qs.stringify({...config.data})
        : config.params = {...config.params};
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    config.headers['platform'] = 'PC';
    const token = sessionStorage.getItem('token');
    if (token != null){
        config.headers['Token'] = token;
    }
    return config;
}, error => {  //请求错误处理
    app.$vux.toast.show({
        type: 'warn',
        text: error
    });
    Promise.reject(error)
});


/****** respone拦截器==>对响应做处理 ******/
service.interceptors.response.use(
    response => {  //成功请求到数据
        app.$vux.loading.hide();
        if (response.status === 200) {
            return response.data;
        } else {
            app.$vux.toast.show({  //常规错误处理
                type: 'warn',
                text: response.data.msg
            });
        }
    },
    error => {  //响应错误处理
        app.$vux.loading.hide();
        console.log('error');
        console.log(error);
        console.log(JSON.stringify(error));

        let text = JSON.parse(JSON.stringify(error)).response.status === 404
            ? '404'
            : '网络异常，请重试';
        app.$vux.toast.show({
            type: 'warn',
            text: text
        });

        return Promise.reject(error)
    }
);
export default service;



// WEBPACK FOOTER //
// ./src/axios/request.js